/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

import * as stagesCase from "../../../Stages/StagesCase";
import personFields from "../modules/personFields";

import { BackofficeUser } from "../../../../types/BackofficeUser";
import { PendingCase } from "../../../../types/Products/PendingCase";

export const fullFormDefinition = (product: PendingCase, currentUser: BackofficeUser) => {
  const incidentBaseCreated = {
    isHidden: ({ product }: { product: PendingCase }) => product.stage! > stagesCase.STAGE_CREATED,
    label: "Allgemeines zum Fall",
    elements: [...personFields({ path: `${product.productClassName}.client`, showDiverseGenderOption: true })],
  };

  const clientDescription = {
    isHidden: ({ product }: { product: PendingCase }) => product.stage! > stagesCase.STAGE_CREATED,
    label: "Angaben zum Fall",
    elements: [
      {
        type: "ValidatorTextField",
        path: `${product.productClassName}.initialClientDescriptionAndObjectives`,
        isDisabled: () => true,
        additionalProps: {
          multiline: true,
          fullWidth: true,
        },
      },
      {
        type: "ValidatorTextField",
        path: `${product.productClassName}.aiRefinementQuestions`,
        isDisabled: () => true,
        additionalProps: {
          multiline: true,
          fullWidth: true,
        },
      },
      {
        type: "ValidatorTextField",
        path: `${product.productClassName}.refinementAnswers`,
        isDisabled: () => true,
        additionalProps: {
          multiline: true,
          fullWidth: true,
        },
      },
    ],
  };

  return {
    product: {
      sections: [incidentBaseCreated, clientDescription],
    },
  };
};
